import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@/app/lib/auth-guard';
import { BillingStatementsPage } from '@/billing/pages/billing-statements';

export const Route = createFileRoute('/billing/statements')({
  beforeLoad: async (ctx) => {
    await requireAuth(ctx);
  },
  component: BillingStatementsRoute,
  staticData: {
    headerSection: 'billing'
  }
});

function BillingStatementsRoute() {
  return <BillingStatementsPage/>;
}
